<template>
  <WdsModal
    :show="internalModelValue"
    :title="$t('Confirm acceptance of the document')"
    :z-index="1100"
    @cancel="internalModelValue = false"
  >
    <template #default>
      <embed :src="contractDoc.pdfUrl" width="100%" height="600" type="application/pdf" />
    </template>

    <template #footer>
      <div class="tw-flex tw-justify-between">
        <WdsButton secondary @click="internalModelValue = false">
          {{ $t('Cancel') }}
        </WdsButton>

        <BaseHtmlForm :action="formAction" method="POST">
          <WdsButton primary data-test="confirm-kid-button">
            {{ $t('Confirm acceptance') }}
          </WdsButton>
        </BaseHtmlForm>
      </div>
    </template>
  </WdsModal>
</template>

<script setup>
import { WdsButton, WdsModal } from '@worksome/wds-components'
import { computed, defineEmits, defineProps } from 'vue'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  contractDoc: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const formAction = computed(() =>
  laravelNamedRoute(namedRoutes['contract-doc'].accept, {
    contractDoc: props.contractDoc.localId,
  }),
)

const internalModelValue = computed({
  get() {
    return props.modelValue
  },
  set(modelValue) {
    emit('update:modelValue', modelValue)
  },
})
</script>
